import axios from 'axios';
import dotenv from 'dotenv';

//import { getBaseURL } from './environment';

const baseURL = ''//getBaseURL();

export const api = axios.create({
  baseURL: baseURL,

});
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

api.interceptors.response.use(response => {
  return response;
}, error => {
  return Promise.reject(error);
});

